import { Capacitor } from "@capacitor/core";

const getPlatform = () => {
  try {
    return Capacitor?.getPlatform?.() || "web";
  } catch {
    return "web";
  }
};

const isLocalHostname = (hostname = "") =>
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname.startsWith("192.168.") ||
  hostname.endsWith(".local");

const inferWebBaseFromLocation = () => {
  try {
    const { origin, hostname } = window.location || {};
    if (!origin || isLocalHostname(hostname)) return null;
    return origin.replace(/\/+$/, "");
  } catch {
    return null;
  }
};

const isCapacitorNative = () => {
  const platform = getPlatform();
  if (platform === "web") return false;
  try {
    return typeof Capacitor?.isNativePlatform === "function"
      ? Capacitor.isNativePlatform()
      : platform !== "web";
  } catch {
    return platform !== "web";
  }
};

const webBaseFromEnv = () =>
  process.env.REACT_APP_API_BASE_URL_WEB ||
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  inferWebBaseFromLocation() ||
  "http://localhost:3000";

const mobileBaseFromEnv = () =>
  process.env.REACT_APP_API_BASE_URL_MOBILE ||
  process.env.REACT_APP_API_BASE_URL_ANDROID ||
  webBaseFromEnv();

/**
 * Resolve the API base URL depending on environment variables and
 * whether we are running inside a Capacitor native shell.
 *
 * Env vars:
 * - REACT_APP_API_BASE_URL_WEB: base for the browser build (e.g. http://localhost:3000).
 * - REACT_APP_API_BASE_URL_MOBILE: base for Android/iOS via Capacitor (e.g. http://10.0.2.2:3000).
 * - REACT_APP_API_BASE_URL / REACT_APP_API_URL: legacy names kept for compatibility.
 */
export const getApiBaseUrl = () => {
  if (isCapacitorNative()) {
    return mobileBaseFromEnv();
  }
  return webBaseFromEnv();
};

export const logApiContext = (label, extra = {}) => {
  try {
    const info = {
      label,
      baseUrl: getApiBaseUrl(),
      href: window.location?.href,
      userAgent: navigator.userAgent,
      isCapacitor: isCapacitorNative(),
      platform: getPlatform(),
      ...extra,
    };
    console.info("[API][context]", info);
  } catch {
    /* noop */
  }
};

console.info("[API] Base URL resolved", {
  resolvedBase: getApiBaseUrl(),
  webBase: webBaseFromEnv(),
  mobileBase: mobileBaseFromEnv(),
  platform: getPlatform(),
  isCapacitorNative: isCapacitorNative(),
});
